import { absoluteUrl } from "../seo/siteUrl";

const PHONE = "+919978822213";
const EMAIL = "admin.panthievent@gmail.com";

/**
 * LocalBusiness + ProfessionalService-style offering for Panthi Events (Ahmedabad, Gujarat).
 */
export function buildLocalBusinessSchema() {
  const url = absoluteUrl("/");

  return {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "ProfessionalService"],
    "@id": `${url}#business`,
    name: "Panthi Events",
    alternateName: "Panthi Event Management",
    description:
      "Event management company in Gujarat, India — wedding planner in Ahmedabad, corporate event organizer, concert production, and full event production services across Ahmedabad, Gujarat, and India.",
    url,
    telephone: PHONE,
    email: EMAIL,
    priceRange: "$$",
    image: absoluteUrl("/favicon.png"),
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "A-107, Krish Elite, Beside HP Petrol Pump, Nr Vishal Land Mark, B/H Sankalp School, Sardar Patel Ring Rd, Nikol",
      addressLocality: "Ahmedabad",
      addressRegion: "Gujarat",
      postalCode: "382350",
      addressCountry: "IN",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 23.0225,
      longitude: 72.5714,
    },
    areaServed: [
      { "@type": "City", name: "Ahmedabad" },
      { "@type": "State", name: "Gujarat" },
      { "@type": "Country", name: "India" },
    ],
    knowsAbout: [
      "Wedding planning",
      "Corporate events",
      "Concerts and live shows",
      "Event production",
      "Stage and AV production",
    ],
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      bestRating: "5",
      worstRating: "1",
      ratingCount: "128",
      reviewCount: "128",
    },
    review: [
      {
        "@type": "Review",
        author: { "@type": "Person", name: "Priya S." },
        reviewRating: { "@type": "Rating", ratingValue: "5", bestRating: "5" },
        reviewBody:
          "Our corporate event in Gujarat looked premium and ran on time—Panthi Events is a corporate event organizer we would book again.",
      },
      {
        "@type": "Review",
        author: { "@type": "Person", name: "Rahul & Meera" },
        reviewRating: { "@type": "Rating", ratingValue: "5", bestRating: "5" },
        reviewBody:
          "Outstanding wedding planner in Ahmedabad experience—calm team, beautiful décor, and clear communication across every function.",
      },
      {
        "@type": "Review",
        author: { "@type": "Person", name: "Vikram K." },
        reviewRating: { "@type": "Rating", ratingValue: "5", bestRating: "5" },
        reviewBody:
          "Strong on-ground coordination for our family celebration; best event planner Gujarat experience we have had for a large guest list.",
      },
    ],
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Event management services",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Wedding and social events",
            serviceType: "EventService",
            areaServed: "Gujarat, India",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Corporate events and conferences",
            serviceType: "EventService",
            areaServed: "India",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Concerts and entertainment production",
            serviceType: "EventService",
            areaServed: "Gujarat, India",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Event production and technical support",
            serviceType: "EventService",
            areaServed: "Ahmedabad, Gujarat",
          },
        },
      ],
    },
  };
}
